import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { kcConfig } from '../../config';
import { formalizedItemFromUrl } from '../utilities/window';

export default interface KeycloakUserRepresentation {
    email?: string;
    firstName?: string;
    lastName?: string;
}

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private _name: string;
    private _id: string;

    constructor(private keycloakAngular: KeycloakService
    ) {

    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }


    /**
     * Function to check if the customer is loggedin
     * 
     * @return promise true/false 
     */
    public async isLoggedIn(): Promise<boolean> {
        return new Promise((resolve) => {
            let instance = this.keycloakAngular.getKeycloakInstance();
            if (!instance?.realm) {
                return resolve(false);
            }

            return resolve(this.keycloakAngular.isLoggedIn());
        })
    }

    /** Get keycloak profile
     * 
     * @return KeycloakProfile as Promise
     */
    public async getUserProfile(): Promise<KeycloakProfile> {
        let instance = this.keycloakAngular.getKeycloakInstance();

        if (!instance?.realm) {
            throw new Error(`Realm not properly configured, can't attempt to retrieve user profile`);
        }

        if (!instance?.authenticated) {
            return;
        }

        return await instance.loadUserInfo();
    }

    /** Redirect to login page */
    public async logIn(): Promise<void> {
        let instance = this.keycloakAngular.getKeycloakInstance();
        if (!instance?.realm) {
            return;
        }

        const { redirectUri, locale } = formalizedItemFromUrl();

        let option = {
            redirectUri: redirectUri,
            locale: locale
        }

        await instance.login(option);
    }

    /* public test(): void {
       let instance = this.keycloakAngular.getKeycloakInstance();
       instance.updateToken(1);
       instance.clearToken();
     }*/

    /* Redirect to logout page */
    public async logOut(): Promise<void> {
        let instance = this.keycloakAngular.getKeycloakInstance();
        if (!instance?.realm) {
            return;
        }

        const { redirectUri } = formalizedItemFromUrl();

        await instance.logout({
            redirectUri: redirectUri
        });
    }

    /* Redirect to register page */
    public async register(): Promise<void> {
        await this.keycloakAngular.register();
    }
}
